<template>
    <div class="flex items-center justify-center p-32">
        <div class="max-w-2xl p-10 text-lg font-medium bg-white border border-l-4 rounded-md shadow border-l-red-500">
            <slot></slot>
        </div>
    </div>
</template>
